import logo from './logo.svg';
import './App.css';
import Portfolio from './Compoents/portfolio';

function App() {
  return (
    <div >
    <Portfolio/>
    </div>
  );
}

export default App;
